/* eslint-disable standard/no-callback-literal */
import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { useAxios } from '../context/AxiosContext';
import { FeatureState, FeatureStatus } from '../context/FeatureToggleContext';

interface Props {
  featureName: string;
  enabled: boolean;
  cb: (data: FeatureState) => void;
}
interface FeatureStatusRequest {
  status: FeatureStatus;
}

export function useFeatureToggleStatus({ featureName, enabled, cb }: Props) {
  const { authAxios } = useAxios();

  const getFeatureStatus = useCallback(async () => {
    const { data } = await authAxios.get<FeatureStatusRequest>(`/feature-toggle-check/${featureName}`);
    return data;
  }, [authAxios, featureName]);

  return useQuery(['feature-toggle-status', featureName], getFeatureStatus, {
    refetchOnWindowFocus: false,
    enabled,
    onSuccess: ({ status }: FeatureStatusRequest) => cb({ [featureName]: status }),
    onError: () => cb({ [featureName]: FeatureStatus.INACTIVE })
  });
}
